export const ANONYMOUS = 'anonymous';
export const BACKEND_DISCONNECT_PROCESSING_DELAY_MS = 1500;

// Max time we wait for a backend ack of a hearing disconnect/cancel before we
// force local teardown. Kept as a single knob to make future tuning trivial.
export const HEARING_TEARDOWN_ACK_WINDOW_MS = 5000;
